import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Renderer } from "@unseenco/taxi";

gsap.registerPlugin(ScrollTrigger);

import GlobalHandler from "../global/global";
import MapHandler from "../global/map";
import FormHandler from "../global/form";
import AnimationHandler from "../partials/animations";
import NavigationHandler from "../global/navigation";
import ScrollHandler from "../global/scroll";
import VideoHandler from "../global/video";
import FilterHandler from "../global/filters";
import LightboxHandler from "../global/lightbox";
import AccordionHandler from "../global/accordions";
import CarouselHandler from "../global/carousel";

const global = new GlobalHandler();
const map = new MapHandler();
const form = new FormHandler();
const animation = new AnimationHandler();
const navigation = new NavigationHandler();
const scroll = new ScrollHandler();
const video = new VideoHandler();
const filter = new FilterHandler();
const lightbox = new LightboxHandler();
const accordion = new AccordionHandler();
const carousel = new CarouselHandler();

export default class RendererDefault extends Renderer {
    initialLoad() {
        this.onEnter(
            global.viewHeight(),
            global.headerHeight(),
            scroll.init(),
            animation.headerNavigation(),
            animation.search(),
            navigation.mobile(),
        );
        this.onEnterCompleted(
            animation.loading(),
        );
    }
    onEnter() {
        animation.parrallax();
        animation.resize();
        animation.headerScroll();
        animation.anchorPoints();
        animation.animations();
        carousel.init();
        video.autoplay();
        navigation.init();
        navigation.reset();
        filter.init();
        lightbox.team();
        accordion.init();
        form.init();
    }
    onEnterCompleted() {
        video.customPlayer();
        map.init();
    }
    onLeave() {
    }
    onLeaveCompleted() {
        let triggers = ScrollTrigger.getAll();
        triggers.forEach((trigger) => {
            trigger.kill();
        });
    }
}


export class RendererLanding extends Renderer {
    initialLoad() {
        this.onEnter(
            global.viewHeight(),
            global.headerHeight(),
            scroll.init(),
            animation.headerNavigation(),
        );
        this.onEnterCompleted(
            animation.loading(),
        );
    }
    onEnter() {
        animation.search();
        animation.accordion();
        animation.parrallax();
        animation.carousel();
        animation.resize();
        animation.headerScroll(),
        animation.anchorPoints(),
        animation.animations(),
        video.autoplay();
        form.init();
    }
    onEnterCompleted() {
        video.customPlayer();
    }
    onLeave() {
    }
    onLeaveCompleted() {
        let triggers = ScrollTrigger.getAll();
        triggers.forEach((trigger) => {
            trigger.kill();
        });
    }
}
